<app-navigation tagline="LINKS" marginLeftClass="ml-70"></app-navigation>
<ion-content>
  <div class="ion-margin slide links">
  <h1>Nützliche Links</h1>
  <h4>Online-Orientierungstests </h4>
  <p>
    Interessentest, Fähigkeitstests, Passung zu Ausbildung und Studium, Studiengangs-, Ausbildungs- und Berufsvorschläge:
    <a href="https://www.was-studiere-ich.de" target="_blank">https://www.was-studiere-ich.de</a>
  </p>
  <p>
    Passung zum dualen Studium: <a href="https://osa.dhbw.de/" target="_blank">https://osa.dhbw.de/</a>
  </p>
  <p>
    Passung zu MINT-Studiengängen (Mathematik, Informatik, Naturwissenschaften, Technik):
    <a href="https://www.komm-mach-mint.de/schuelerinnen/teste-dich-selbst/self-assessments" target="_blank">https://www.komm-mach-mint.de/schuelerinnen/teste-dich-selbst/self-assessments</a>
  </p>
  <p>
    Beispielaufgaben aus dem Studium: <a href="https://www.bwquadrat.de" target="_blank">https://www.bwquadrat.de</a>
  </p>
  <p>
    Persönliches Kompetenzprofil, Vorschläge zu passenden Ausbildungsberufen und Studienfeldern:
    <a href="https://www.arbeitsagentur.de/bildung/welche-ausbildung-welches-studium-passt" target="_blank">https://www.arbeitsagentur.de/bildung/welche-ausbildung-welches-studium-passt</a>
  </p>
  <h4>
    Informationen zur Ausbildung
  </h4>
  <p>
    Umfangreiche Infos rund um das Thema Ausbildung: <a href="https://www.gut-ausgebildet.de/" target="_blank">https://www.gut-ausgebildet.de/</a>
  </p>
  <p>
    Servicestelle Auslandspraktikum für Azubis: <a href="https://www.goforeurope.de/" target="_blank">https://www.goforeurope.de/</a>
  </p>
  <p>
    App Azubiwelt zur Ausbildungssuche:
    <a href="https://www.arbeitsagentur.de/bildung/ausbildung/azubiwelt" target="_blank">https://www.arbeitsagentur.de/bildung/ausbildung/azubiwelt</a>
  </p>
  <p>
    Verkürzung der Ausbildungsdauer für Abiturientinnen und Abiturienten:
    <a target="_blank" href="https://www.arbeitsagentur.de/bildung/ausbildung/ausbildungsdauer-verkuerzung-verlaengerung-teilzeitberufsausbildung">
    https://www.arbeitsagentur.de/bildung/ausbildung/ausbildungsdauer-verkuerzung-verlaengerung-teilzeitberufsausbildung
    </a>
  </p>
  <p>
    Ausbildungsberufe zappen & Infos auf YouTube: <a href="https://www.youtube.com/user/berufezappen" target="_blank">https://www.youtube.com/user/berufezappen</a>
  </p>
  <p>
    Argumente, die für eine Ausbildung sprechen: <a href="https://www.ja-zur-ausbildung.de/" target="_blank">https://www.ja-zur-ausbildung.de/</a>
  </p>
  <h4>Informationen zum Studium</h4>
  <p>Infos zu den unterschiedlichen Hochschultypen: <a target="_blank" href="https://studienwahl.de/studieninfos/hochschultypen">https://studienwahl.de/studieninfos/hochschultypen</a></p>
  <p>Infos zum dualen Studium in Baden-Württemberg: <a target="_blank" href="https://www.dhbw.de/informationen/studieninteressierte">https://www.dhbw.de/informationen/studieninteressierte</a></p>
  <p>Infos zum Studieren ohne Abitur: <a target="_blank" href="http://www.studieren-ohne-abitur.de/web/information/ueberblick/">http://www.studieren-ohne-abitur.de/web/information/ueberblick/</a></p>
  <p>Umfangreiche Infos rund ums Thema Studieren und Promovieren: <a target="_blank" href="https://www.hochschulkompass.de/home.html">https://www.hochschulkompass.de/home.html</a></p>

</div>
</ion-content>
<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-title class="footer">#ORIENTANDO</ion-title>
  </ion-toolbar>
</ion-footer>
